import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
// import { VochatToFalla } from 'src/helper/domain'
import { getlangV2, setlang } from 'src/helper/getlang'
import Rule from './Rule'
import Nav from './Nav'
import Nav2 from './Nav2'
import Top from './Top'
import Countdown from './Countdown'
import Prize from './Prize'
import List from './List'
import GroupList from './GroupList'
import Copyright from './Copyright'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.turkeyStore = this.props.store.register('activity/202408tr')
  }
  state = {
    loading: false,
    lang: langM.ar,
    nav: 1,
    nav2: 2,
    nav3: 1,
    uid: '',
    language:'',
  }

  hideRule = async (status) => {
    this.refs.rule.hideRule(status)
  }

  hideShare = async (status) => {

  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlangV2(language, langM)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    // await this.turkeyStore.GetUserInfoWeb(uid)
    await this.RunOnStart(uid)
  }

  //初始化
  RunOnStart = async (uid) => {
    this.setState({ uid: uid })
    this.turkeyStore.GetTimeinfo()
    this.turkeyStore.GetGiftinfo()
    this.turkeyStore.GetRanklist()
    this.turkeyStore.GetRewardlist()
    // this.turkeyStore.Rank(2)
    // this.turkeyStore.Rank(1)
    // this.turkeyStore.GroupRank(2)
    // this.turkeyStore.GroupRank(1)
  }

  componentDidMount() {
    let that = this
    setTimeout(() => {
      setDocumentTitle(that.state.lang.toptitle)
    }, 1500)
  }

  changeNav = async (nav) => {
    this.setState({
      nav: nav
    })
  }

  changeNav2 = async (nav) => {
    this.setState({
      nav2: nav
    })
  }

  changeNav3 = async (nav) => {
    this.setState({
      nav3: nav
    })
  }

  tabContent1 = (language, list, mine) => {
    return (
      <div className={`tabContent1 ${this.state.nav == 1 ? 'block' : 'none'}`}>
        {/* <div style={{ height: '0.12rem' }}></div> */}
        <div className={`block`}>
          <List language={language} lang={this.state.lang} list={list} myrank={mine} />
        </div>
        {/* <div className={`${this.state.nav2 == 2 ? 'block' : 'none'}`}>
          <List language={language} lang={this.state.lang} list={list.country} myrank={list.countryMyrank} />
        </div> */}
      </div>
    )
  }

  tabContent2 = (language, groupRank) => {
    return (
      <div className={`tabContent2 ${this.state.nav == 2 ? 'block' : 'none'}`}>
        <div style={{ height: '0.12rem' }}></div>
        <GroupList language={language} lang={this.state.lang} list={groupRank.world} myrank={groupRank.worldMyrank} />
      </div>
    )
  }

  tabContent3 = (language, rewardlist) => {
    return (
      <div className={`tabContent3 ${this.state.nav == 2 ? 'block' : 'none'}`}>
        {/* <div style={{ height: '1rem' }}></div> */}
        <Prize language={language} lang={this.state.lang} nav2={this.state.nav2} rewardlist={rewardlist}/>
      </div>
    )
  }

  render() {
    let { language } = this.state
    let { remaintime, rankUser, rankGroup, now, gifts, rank, mine, rewardlist } = this.turkeyStore.data
    return (
      <div className={`algeria ${language == 'ar' && 'arlang'}`}>
        <Top language={language} lang={this.state.lang} gifts={gifts} />
        <Countdown language={language} lang={this.state.lang} remaintime={remaintime} now={now} />
        <div style={{ height: '0.4rem' }}></div>
        <Nav language={language} lang={this.state.lang} nav={this.state.nav} changeNav={this.changeNav.bind(this)} />
        {/* {(this.state.nav == 1 || this.state.nav == 3) && <div style={{ height: '0.4rem' }}></div>} */}
        {/* {(this.state.nav == 1 || this.state.nav == 3) && (
          <Nav2
            language={language}
            lang={this.state.lang}
            nav={this.state.nav2}
            changeNav2={this.changeNav2.bind(this)}
          />
        )} */}
        {/* <Nav2
            language={language}
            lang={this.state.lang}
            nav={this.state.nav2}
            changeNav2={this.changeNav2.bind(this)}
          /> */}
        {/* <div style={{ height: '0.3rem' }}></div> */}
        {this.tabContent1(language, rank, mine)}
        {/* {this.tabContent2(language, rankGroup)} */}
        {this.tabContent3(language, rewardlist)}
        {/* <div className="share" onClick={this.hideShare.bind(this, true)}>
          {this.state.lang.share}
        </div> */}
        <div className="rules" onClick={this.hideRule.bind(this, true)}>
          {this.state.lang.rule}
        </div>
        <Rule language={language} lang={this.state.lang} ref="rule" />
        <Copyright language={language} lang={this.state.lang} />
        <div className="cache">
          <img src="/img/activity/202408tr/bg3.jpg" />
          <img src="/img/activity/202408tr/ruleBox.png" />          
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/202408tr/index.js